import { Phone, MessageCircle, ArrowDown, CheckCircle2 } from "lucide-react";
import { toTelDigits } from "../lib/phone";

export const Hero = ({ phone, whatsapp }) => {
  return (
    <section
      data-testid="hero-section"
      className="relative pt-40 md:pt-52 pb-20 md:pb-28 bg-slate-50 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7">
          <div
            data-testid="hero-overline"
            className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] font-semibold text-blue-600 mb-6"
          >
            <span className="w-8 h-px bg-blue-600" />
            Now Hiring · Nationwide
          </div>

          <h1
            data-testid="hero-headline"
            className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter text-slate-900 leading-[1.02]"
          >
            Knock. Close.
            <br />
            <span className="text-blue-600">Earn 100%</span> commission.
          </h1>

          <p
            data-testid="hero-subhead"
            className="mt-6 text-base md:text-lg text-slate-600 leading-relaxed max-w-2xl"
          >
            Join Knockwave Telecom — the door-to-door residential sales team
            powering a leading telecom provider. High-energy reps. Uncapped
            earning potential. Real territory. Real results.
          </p>

          <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-3">
            {[
              "100% Commission",
              "Bi-Weekly Compensation",
              "Field Training Provided",
              "Nationwide Territories",
            ].map((item) => (
              <li
                key={item}
                className="flex items-center gap-2 text-sm font-medium text-slate-700"
              >
                <CheckCircle2 className="w-4 h-4 text-blue-600" />
                {item}
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <a
              data-testid="hero-call-cta"
              href={`tel:${toTelDigits(phone)}`}
              className="inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-4 rounded-md transition-all hover:-translate-y-0.5 shadow-sm hover:shadow-md"
            >
              <Phone className="w-5 h-5" />
              Call to Apply · {phone}
            </a>
            <a
              data-testid="hero-whatsapp-cta"
              href={`https://wa.me/${toTelDigits(whatsapp)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1EBE5A] text-white font-semibold px-6 py-4 rounded-md transition-all hover:-translate-y-0.5"
            >
              <MessageCircle className="w-5 h-5" />
              WhatsApp Us
            </a>
          </div>

          <button
            data-testid="hero-scroll-cue"
            onClick={() =>
              document
                .getElementById("benefits")
                ?.scrollIntoView({ behavior: "smooth" })
            }
            className="mt-12 inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 transition-colors"
          >
            <ArrowDown className="w-4 h-4 animate-bounce" />
            See why reps are switching to Knockwave
          </button>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-full h-full border-2 border-blue-600 -z-0" />
            <img
              data-testid="hero-image"
              src="https://images.unsplash.com/photo-1758691736433-4078b93abd72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHNhbGVzJTIwdGVhbSUyMGNvbmZpZGVudCUyMGhpZ2glMjBmaXZlfGVufDB8fHx8MTc3ODYzODg2MHww&ixlib=rb-4.1.0&q=85"
              alt="Knockwave sales team"
              className="relative w-full h-[420px] md:h-[520px] object-cover grayscale-[0.15]"
            />
            <div className="absolute bottom-6 left-6 right-6 bg-white border border-slate-200 p-5 shadow-lg">
              <div className="flex items-center gap-4">
                <div className="flex -space-x-2">
                  {[
                    "https://images.pexels.com/photos/17582358/pexels-photo-17582358.jpeg",
                    "https://images.unsplash.com/photo-1623594675959-02360202d4d6?crop=entropy&cs=srgb&fm=jpg&w=120",
                  ].map((src, i) => (
                    <img
                      key={i}
                      src={src}
                      alt=""
                      className="w-9 h-9 rounded-full border-2 border-white object-cover"
                    />
                  ))}
                  <span className="w-9 h-9 rounded-full border-2 border-white bg-slate-900 text-white text-xs font-bold flex items-center justify-center">
                    +47
                  </span>
                </div>
                <div>
                  <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">
                    Reps onboarded this month
                  </p>
                  <p className="text-sm font-semibold text-slate-900">
                    Be the next to join.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
